import { isSSR } from 'app/packages/components';

export const freshchatConfig = !isSSR && {
  token: window.__env.FRESHCHAT_TOKEN,
  widgetUuid: window.__env.FRESHCHAT_UUID,
  host: window.__env.FRESHCHAT_HOST,
  config: {
    headerProperty: {
      hideChatButton: true,
    },
  },
};
